import { clone, cloneDeep, isArray, isDate, isObject, set, setWith } from 'lodash'
import moment from 'moment'

/*
  Apollo side will create __typename to entities
  This function will remove __typename attribute recursively
  Details: https://www.apollographql.com/docs/react/caching/cache-configuration/#configuration-options
*/

export const removeTypeName = (profile: any) => {
  for (const attribute in profile) {
    const obj = profile[attribute]
    if (isArray(obj)) {
      obj.forEach((item) => removeTypeName(item))
    }
    if (isObject(obj)) {
      removeTypeName(obj)
    }
    if (attribute === '__typename') {
      delete profile[attribute]
    }
  }
}

export function setProfilePartialAttribute<T>(
  profile: Partial<T>,
  root: T,
  attributeChain: string,
  value: string | boolean,
  setEditProfile: React.Dispatch<React.SetStateAction<T | undefined>>
) {
  setWith(profile, attributeChain.split('.'), value, clone)
  setEditProfile(cloneDeep(root))
}

export function setCareerPartialAttribute<T>(
  partial: Partial<T>,
  index: number,
  root: T[],
  attributeChain: string,
  value: string | boolean,
  setEditProfile: React.Dispatch<React.SetStateAction<T[] | undefined>>
) {
  setWith(partial, attributeChain, value, clone)
  set(root, index, partial)
  setEditProfile(cloneDeep(root))
}

export function getDateRange(s: string) {
  let res
  const dates = s.split(' - ')
  const [start, end] = dates

  if (dates.length === 2 && isDate(new Date(start)) && isDate(new Date(end))) {
    res = [moment(start), moment(end)]
  } else if (dates.length === 1 && isDate(start)) {
    res = [moment(start), moment()]
  } else {
    res = [moment(), moment()]
  }

  return res as [any, any]
}
